import makeNbsp from '@glass/common/modules/utils/makeNbsp';

export const ROCK_BRAND = 'rock';
export const LAMBO_BRAND = 'lambo';
export const RAPTOR_BRAND = 'raptor';
export const CHEETAH_BRAND = 'cheetah';
export const TAXONOMY_BRAND = 'taxonomy';

export const BRAND_TITLE_NBSP = makeNbsp(process.env.NEXT_PUBLIC_BRAND_TITLE || '');
